"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// in px
var _default = exports["default"] = {
  XS: 0,
  // extra small
  SM: 376,
  // small
  MD: 568,
  // medium
  LG: 768,
  // large
  XL: 1200 // extra large
};